<div class="title mb-4">
	<h2>Forum Polling</h2>
</div>

<div class="row">
	<div class="col-lg-12 col-md-12">
		<div class="white_box shadow p-3">

			<div class="btn-group mb-3">
				<button [routerLink]="['/admin/forum-polling']" class="btn btn-primary">
					Polling
				</button>
				<button [routerLink]="['/admin/forum-giveaway']" class="btn btn-light">
					Giveaway
				</button>
			</div>
			<form>
				<div class="mb-3 row">
					<!-- <label for="table-filtering-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label> -->
					<div class="col-xs-3 col-sm-auto">
						<button type="button" (click)="openForm(pollForm)" class="btn btn-success btn-sm mb-2">
							<i class="fa-solid fa-plus"></i> Create
						</button>
					</div>
					<!-- <div class="col-xs-3 col-sm-auto">
						<input id="table-filtering-search" class="form-control" type="text" placeholder="Search"
							[formControl]="filter" />
					</div> -->
				</div>
			</form>

			<!-- Table -->
			<section>
				<table class="table table-striped">
					<thead>
						<tr>
							<th scope="col">#</th>
							<th scope="col">Title</th>
							<th scope="col">Start Date</th>
							<th scope="col">End Date</th>
							<th scope="col">Polling Count</th>
							<th scope="col">Action</th>
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let item of polls?.data; track item?.name; index as i">
							<tr>
								<th scope="row">{{ i + 1 }}</th>
								<td>{{item?.name}}</td>
								<td>{{item?.startDate}}</td>
								<td>{{item?.endDate}}</td>
								<td>{{item?.poll_details?.length}}</td>
								<td>
									<div class="btn-group">
										<button class="btn btn-sm btn-warning" (click)="openForm(pollForm, item)">
											<i class="fa-solid fa-edit"></i> Edit
										</button>
										<button class="btn btn-sm btn-danger" (click)="deletePoll(item.id)">
											<i class="fa-solid fa-trash"></i> Delete
										</button>
									</div>
								</td>
							</tr>
						</ng-container>

						<!-- <tr>
																	<td colspan="4" style="text-align: center">No countries found</td>
															</tr> -->
					</tbody>
				</table>
			</section>
			<!-- Table -->
		</div>
	</div>
</div>

<ng-template #pollForm let-modal>
	<div id="poll_form_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
		<form (submit)="storePoll()">
			<div class="modal-body">
				<h5 class="text-center">
					Create New Poll
				</h5>
				<div class="form-group">
					<label for="">Title</label>
					<input ngRequr type="text" [(ngModel)]="poll.name" [ngModelOptions]="{standalone: true}"
						class="form-control">
				</div>
				<div class="row">
					<div class="form-group col-sm-6">
						<label for="">Start Date</label>
						<input ngRequr type="date" [(ngModel)]="poll.startDate" [ngModelOptions]="{standalone: true}"
							class="form-control">
					</div>
					<div class="form-group col-sm-6">
						<label for="">End Date</label>
						<input ngRequr type="date" [(ngModel)]="poll.endDate" [ngModelOptions]="{standalone: true}"
							class="form-control">
					</div>
				</div>
				<button class="btn btn-primary mb-3" type="button" (click)="addPollsChild()">
					<i class="fa-solid fa-plus"></i> Add Poll
				</button>
				<div class="form-group" *ngFor="let row of poll.polls; let i = index">
					<label for="">Polling {{ i + 1 }}</label>
					<div class="d-flex">
						<input ngRequr type="text" [(ngModel)]="row.name" placeholder="Title for Polling {{ i + 1 }}"
							[ngModelOptions]="{standalone: true}" class="form-control">
						<button class="btn btn-danger btn-sm ml-2" (click)="removePollsChild(i)">
							<i class="fa-solid fa-trash"></i>
						</button>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-danger mr-2" [disabled]="poll?.hasSubmit"
					(click)="modalService.dismissAll()">
					<i class="fa-solid fa-times"></i> Cancel
				</button>
				<button class="btn btn-primary" type="submit" [disabled]="poll?.hasSubmit">
					<i class="fa-solid fa-paper-plane"></i> Submit
				</button>
			</div>
		</form>
	</div>
</ng-template>